module.exports = __webpack_public_path__ + "static/media/logo.6dd54978.png";